import React from 'react'
import { Navigate } from 'react-router-dom'
import demo from './demo'
import tasks from './tasks'
import { IRoute } from './types'
import taskInfo from './taskInfo'
import liveCheck from './liveCheck'
import MMCPlayer from './mmcPlayer'
import templateConfig from './templateConfig'
import policyViewMode from './policyViewMode'
import agentManagement from './agentManagement'
import queueManagement from './queueManagement'
import overallDashboard from './overallDashboard'
import { exportRecord, uploadRecord } from './exportRecord'

const ImagesReview = React.lazy(() => import('@/pages/ImagesReview'))

const routes: IRoute[] = [
  ...tasks,
  ...taskInfo,
  ...overallDashboard,
  ...queueManagement,
  ...agentManagement,
  exportRecord,
  uploadRecord,
  policyViewMode,
  ...templateConfig,
  liveCheck,
  demo,
  MMCPlayer,
  {
    label: '',
    path: '/images',
    hiddenMenu: true,
    hiddenHeader: true,
    notUseForMenu: true,
    element: <ImagesReview />
  },
  {
    label: '',
    path: '*',
    element: <Navigate to='/task-list' />
  }
]

if (DEPLOY_ENV === 'development') {
  routes.splice(routes.length - 2, 0, demo)
}

export default routes

export type { IRoute }
